/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Birth_Date_LabelInputs */

const en_signup_birth_date_label = /** @type {(inputs: Signup_Birth_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of birth`)
};

const pl_signup_birth_date_label = /** @type {(inputs: Signup_Birth_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data urodzenia`)
};

/**
* | output |
* | --- |
* | "Date of birth" |
*
* @param {Signup_Birth_Date_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const signup_birth_date_label = /** @type {((inputs?: Signup_Birth_Date_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Birth_Date_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_signup_birth_date_label(inputs)
	return en_signup_birth_date_label(inputs)
});